// extracted by mini-css-extract-plugin
export default {"days":"PathDays_days__8wGG9","active":"PathDays_active__8I0UI","days__mobile":"PathDays_days__mobile__sZN+d"};